import React, { createContext, useContext } from 'react'

import { PhysicalContractDeliveryType } from '@enechain/eposition-proto/bfftypes/v1/contract_pb'

export type FloatingIndexOption = { label: string; value: string }

// 注文の入力フォームが、アプリごとに取り方の違う値を受け取るための口。
// portal はログイン組織から、dev-tool は画面で選んだ組織から渡す。
export type OrderSimulationContextValue = {
  // 注文する組織の受渡区分。現物の自社受渡区分の初期値に使う
  deliveryType: PhysicalContractDeliveryType | undefined
  // 燃調指数の選択肢を返す hook。enabled が false のときは取得しなくてよい
  useFloatingIndexOptions: (enabled: boolean) => FloatingIndexOption[]
}

const OrderSimulationContext = createContext<
  OrderSimulationContextValue | undefined
>(undefined)

export const OrderSimulationProvider: React.FC<
  React.PropsWithChildren<{ value: OrderSimulationContextValue }>
> = ({ value, children }) => (
  <OrderSimulationContext.Provider value={value}>
    {children}
  </OrderSimulationContext.Provider>
)

export function useOrderSimulationContext(): OrderSimulationContextValue {
  const value = useContext(OrderSimulationContext)
  if (value === undefined) {
    throw new Error(
      'useOrderSimulationContext must be used within OrderSimulationProvider',
    )
  }
  return value
}
